import { Abwesenheit } from '@/domain/mitarbeiter/features/rotationsplan/entities/Abwesenheit';
import {
  Body,
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@e2n/ui/v2';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function AbwesenheitenPopover({
  abwesenheiten,
}: {
  abwesenheiten: Abwesenheit[];
}) {
  const { t } = useTranslation();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          iconOnly
          size="small"
          variant="ghost"
          className="size-7 p-1 text-labels-secondary">
          <FontAwesomeIcon className="size-3.5" icon={faCircleInfo} />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        side="right"
        align="center"
        className="p-4 flex flex-col gap-2 md:min-w-85">
        <Body weight="semibold">
          {t(
            'domain.mitarbeiter.rotationsplan.rotationsplaene.abwesenheitPopover.title',
          )}
        </Body>
        {abwesenheiten.map((abwesenheit) => (
          <div
            key={abwesenheit.id}
            className="flex justify-between items-center gap-4">
            <div className="flex items-center gap-2 min-w-0">
              <FontAwesomeIcon
                className="size-4 text-labels-primary"
                icon={abwesenheit.abwesenheitsgrundIcon}
              />
              <Body className="truncate">{abwesenheit.grund}</Body>
            </div>
            <Body className="whitespace-nowrap">
              {abwesenheit.zeitraumLabel}
            </Body>
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
}
